<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.reasons_declining_order.add.title") }}
    </h4>
    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitNewType)">
        <div class="row text-left">
          <div
            :class="sizes"
            v-for="lang in item.traducciones"
            :key="lang.idLenguaje"
          >
            <ValidationProvider
              :name="$t('app.modules.reasons_declining_order.headers.reason')"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="failed ? required_text : null"
                :hasSuccess="passed"
                :placeholder="lang.idioma"
                :label="
                  $t('app.modules.reasons_declining_order.headers.reason')
                "
                v-model="lang.declinacionDescripcion"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-sm-6 form-group has-label">
          <div style="margin-bottom: -5px; margin-left: -12px;">
            <label>{{ $t("app.general.state") }}</label>
          </div>
          <template>
            <n-switch v-model="item.activo">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </template>
        </div>
        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button
            class="pull-left btn-secondary"
            @click.native="cancelAdd()"
            >{{ $t("app.buttons.cancel") }}</n-button
          >
          <n-button native-type="submit" type="primary">{{
            $t("app.buttons.save")
          }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      required_text: this.$t("app.general.required"),
      sizes: "col-md-6 col-sm-12",
      item: {
        idTipoDocPedido: 0,
        nombreMotivo: "",
        activo: true,
        accion: "Alta",
        usuariosIdUsuario: 0,
        fecha: "2020-11-10T15:30:46.239Z"
      },
      modals: {
        classic: false
      }
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapState(["availableLangs"])
  },
  created() {
    console.log(this.user);
    this.item.traducciones = this.availableLangs.map(lang => ({
      idDeclinacionTraduccion: 0,
      declinacionPedido_idDeclinacionPedido: 0,
      declinacionDescripcion: "",
      idioma_idIdioma: lang.idIdioma,
      idioma: lang.idioma
    }));
    this.item.usuariosIdUsuario = this.user.idUsuario;
  },
  mounted() {
    EventBus.$on("reason-declining-add", async () => {
      this.tableData = [];
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.$swal.close();
      this.modals.classic = true;
    });
  },
  methods: {
    async submitNewType() {
      console.log(this.item);
      await this.$http
        .post(route("DeclinacionPedido/addDeclinacionPedido"), this.item)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              EventBus.$emit("reload-items-motivos");
              this.cancelAdd();
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.trubbleSave = true;
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    cancelAdd() {
      for (let lang of this.item.traducciones) {
        lang.declinacionDescripcion = "";
      }
      this.item.nombreMotivo = "";
      this.modals.classic = false;
      this.$refs.formAdd.reset();
    },
    async submitNewUsuario() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.addNewRole();
      this.$swal.close();
    },
    async addNewRole() {}
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
